export default "__VITE_ASSET__dhmIyyVL__";